<template>
    <div class="content_box mobile_content">
        <div class="content">
            <div class="title_box">
                <div class="title">
                    <span>SN号管理</span>
                </div>
            </div>
            <div class="search_box">
                <el-form :inline="true" :model="searchData" class="demo-form-inline search-form form-list">
                    <el-form-item>
                        <el-select v-model="searchData.product_type" filterable clearable placeholder="产品型号" :no-data-text="'暂无数据'">
                            <el-option :label="item" :value="item" v-for="item in productType" :key="item + '12345'"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="SN号" class="form_item">
                        <el-input placeholder="请输入" v-model="searchData.sn"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <div class="button search" @click="search">
                            <span>查询</span>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <div class="btn_box">
                <div class="button import" @click="openDialog('import', '导入工单')" v-if="roleCheck('105-101-102-102') && $store.state.type == 'pc'">
                    <span>导入</span>
                </div>
            </div>
            <el-table
                highlight-current-row
                :data="listData">
                <el-table-column prop="product_type" label="产品型号" min-width="100px"></el-table-column>
                <el-table-column prop="sn_start" label="起始SN号" ></el-table-column>
                <el-table-column prop="sn_num" label="流水个数" min-width="100px"></el-table-column>
            </el-table>
            <Pagination :total="total" :page="searchData.page" @paginationChange="paginationChange"></Pagination>
        </div>
        <importFileComponents ref="importFile" name="SN号" :uploadUrl="uploadUrl" downloadUrl="downloadSnFile" title="导入SN号" @uploadChange="uploadChange"></importFileComponents>
    </div>
    
</template>
<script>
import importFileComponents from '../../../components/dialog/import-file'
export default({
    name: 'sn-manage',
    data() {
        return {
            searchData: {
                product_type: '',
                sn: '',
                page: 1,
                page_size: 10
            },
            productType: [],
            listData: [],
            total: 0,
            importFile: [],
            uploadUrl: process.env.BASE_API + 'product/sn-import',
            downloadSnFile: 'downloadSnFile',
            importTip: '支持 xlsx文件，最多不超过1000行'
        }
    },
    components: {
        importFileComponents
    },
    watch: {
    },
    created() {
        this.getSnProductType();
        this.getList();
    },
    methods: {
        search() {
            this.searchData.page = 1;
            this.getList();
        },
        openDialog() {
            this.$refs.importFile.openDialog();
        },
        uploadChange(file, fileList) {
            this.getList();
        },
        getSnProductType() {
            this.api.getSnProductType({}).then(data => {
                this.productType = data.data.data || [];
            })
        },  
        getList() {
            this.api.getSnList(this.searchData).then(data => {
                this.listData = data.data.data.list;
                this.total = data.data.data.totalCount;
            })
        },
        paginationChange(data) {
            this.searchData.page_size = data.page_size;
            this.searchData.page = data.page;
            this.getList();
        }
    }
})
</script>
<style lang="less" scoped>
    
</style>



// WEBPACK FOOTER //
// src/view/product/product-data/sn-manage.vue